import type { LucideIcon } from "lucide-react";

interface Props {
  icon: LucideIcon;
  /** Tooltip and accessible name (icon-only controls always need one). */
  label: string;
  onClick?: () => void;
  disabled?: boolean;
  active?: boolean;
  testId?: string;
  size?: number;
}

export function IconButton({ icon: Icon, label, onClick, disabled, active, testId, size = 15 }: Props) {
  return (
    <button
      type="button"
      className={`icon-btn${active ? " active" : ""}`}
      title={label}
      aria-label={label}
      aria-pressed={active}
      disabled={disabled}
      onClick={onClick}
      data-testid={testId}
    >
      <Icon size={size} strokeWidth={1.75} aria-hidden />
    </button>
  );
}
